import { Observable } from 'rxjs';
import { BaseController } from '~client/controller/base-controller';
import { CheckoutResponse } from '~client/model/checkout-response';
import { DateFilterType } from '~client/model/date-filter-type';
import { OfferGroupResponse } from '~client/model/offer-group-response';
import { ResaleOfferGroup } from '~client/model/resale-offer-group';
import { ResponseEntity } from '~client/model/response-entity';
import { SecondaryExchangeOfferGroupRequest } from '~client/model/secondary-exchange-offer-group-request';
import { SecondaryListingsResponse } from '~client/model/secondary-listings-response';
import { SecondaryMarketplaceDetailsResponse } from '~client/model/secondary-marketplace-details-response';
import { UserSecondaryListings } from '~client/model/user-secondary-listings';

/* User APIs pertaining to Secondary Resale listings */
export class ResaleController extends BaseController {
  /* Creates a listing for a resale Marketplace */
  public createResaleListing$(
    request: SecondaryExchangeOfferGroupRequest,
  ): Observable<OfferGroupResponse> {
    return this.post$('/secondaryListing', request);
  }

  /* Deletes a resale listing */
  public deleteResaleListing$(offerGroupId: string): Observable<ResponseEntity> {
    return this.del$('/secondaryListing', { offerGroupId });
  }

  /* Returns a list of offer group IDs the user has in the given event. */
  public getResaleOfferGroups(eventId: string): Promise<UserSecondaryListings> {
    return this.get(`/secondaryListingOfferGroups`, { eventId });
  }

  /* Returns resale offer group details for a specific offer group. */
  public getResaleOfferGroupDetails$(offerGroupId: string): Observable<ResaleOfferGroup> {
    return this.get$(`/secondaryListing/details`, { offerGroupId });
  }

  /* Returns a list of the user's active secondary listings */
  public getResaleListings(dateFilterType: DateFilterType): Promise<SecondaryListingsResponse> {
    return this.get('/secondaryListings', { dateFilterType });
  }

  /*
  @deprecated
  Returns a list of the user's active secondary listings
  */
  public getResaleListings$(dateFilterType: DateFilterType): Observable<SecondaryListingsResponse> {
    return this.get$('/secondaryListings', { dateFilterType });
  }

  /* Returns details of secondary market, including pricing details of similar inventory items. */
  public getSecondaryMarketplaceDetails$(
    inventoryItemId: string,
  ): Observable<SecondaryMarketplaceDetailsResponse> {
    return this.get$('/secondaryMarketplaceDetails', { inventoryItemId });
  }

  /* Returns the price breakdown for the inventory a user is trying to sell. */
  public reviewResaleListing$(
    request: SecondaryExchangeOfferGroupRequest,
  ): Observable<CheckoutResponse> {
    return this.put$('/sellerCheckout', request);
  }

  /* Retry payout with a new payout method for a failed payout. */
  public retryPayout$(offerGroupId: number, payoutMethodId: number): Observable<ResaleOfferGroup> {
    return this.put$(
      `/secondaryListing/retryPayout?offerGroupId=${offerGroupId}&payoutMethodId=${payoutMethodId}`,
    );
  }

  /* Updates the payout method of a listing (before payouts are initiated). */
  public updatePayoutMethod$(
    offerGroupId: number,
    payoutMethodId: number,
  ): Observable<ResaleOfferGroup> {
    return this.put$(
      `/secondaryListing/updatePayoutMethod?offerGroupId=${offerGroupId}&payoutMethodId=${payoutMethodId}`,
    );
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src891534606/src/modules/client/src/controller/resale-controller.ts